import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-config-login',
  templateUrl: './config-login.component.html',
  styleUrls: ['./config-login.component.scss']
})
export class ConfigLoginComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
